const TrainerStats = ({ stats }) => (
  <div className="staff-metrics" style={{ gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' }}>
    <div className="staff-metric">
      <span className="staff-metric-label">Linked batches</span>
      <span className="staff-metric-value">{stats.batches ?? stats.assignedBatches ?? 0}</span>
    </div>
    <div className="staff-metric">
      <span className="staff-metric-label">Courses</span>
      <span className="staff-metric-value">{stats.courses || 0}</span>
    </div>
    <div className="staff-metric">
      <span className="staff-metric-label">Related students</span>
      <span className="staff-metric-value">{stats.students || 0}</span>
    </div>
  </div>
);

export default TrainerStats;
